(function designerPreviewInjector() {
    'use strict';

    const CONTAINER_SELECTOR = '#qikify-stickycart-v2-app';
    const ITEM_SELECTOR = '.qsc2-product-item';
    const PREVIEW_CLASS = 'designer-design-preview';
    const MAX_WAIT_MS = 10_000; // Wait maximum 10 seconds for qikify, before stopping this script
    const DEBUG = false;

    const log = (...args) => DEBUG && console.log('[designer]', ...args);
    const warn = (...args) => console.warn('[designer]', ...args);

    let cartCache = null;
    let refreshPromise = null;
    let observer = null;
    let active = false;

    async function refreshCart() {
        if (refreshPromise) return refreshPromise;
        refreshPromise = fetch('/cart.js')
            .then(r => r.json())
            .then(c => { cartCache = c; refreshPromise = null; return c; })
            .catch(e => {
                refreshPromise = null;
                warn('cart fetch failed', e);
                return null;
            });
        return refreshPromise;
    }

    function buildPreviewEl(designUrl, designId) {
        const wrap = document.createElement('div');
        wrap.className = PREVIEW_CLASS;
        wrap.dataset.designId = String(designId);
        wrap.style.cssText = 'margin-top:8px;';

        const label = document.createElement('span');
        label.style.cssText = 'font-size:11px;color:#999;';
        label.textContent = `Design: (id: ${designId})`;

        const img = document.createElement('img');
        img.src = designUrl;
        img.alt = 'Dein Design';
        img.style.cssText = 'max-width:80px;max-height:80px;display:block;' +
            'border:1px solid #e0e0e0;border-radius:4px;' +
            'margin-bottom:4px;background:#f5f5f5;';
        img.className = 'designer-preview-thumb';

        wrap.appendChild(label);
        wrap.appendChild(document.createElement('br'));
        wrap.appendChild(img);
        return wrap;
    }

    function injectAll() {
        if (!cartCache || !active) return;

        observer?.disconnect();

        try {
            const itemEls = document.querySelectorAll(ITEM_SELECTOR);
            log('inject DOM:', itemEls.length, 'cart:', cartCache.items.length);

            itemEls.forEach((itemEl, idx) => {
                try {
                    const lineItem = cartCache.items[idx];
                    if (!lineItem) return;

                    const props = lineItem.properties || {};
                    const designUrl = props._design_url;
                    const designId = props._design_id;

                    const existing = itemEl.querySelector('.' + PREVIEW_CLASS);

                    if (existing && existing.dataset.designId === String(designId)) return;
                    existing?.remove();

                    if (!designUrl) return;

                    // Sanity check Variant-ID
                    const linkVariant = itemEl.querySelector('a[href*="variant="]')
                        ?.getAttribute('href')?.match(/variant=(\d+)/)?.[1];
                    if (linkVariant && String(lineItem.variant_id) !== linkVariant) {
                        log('Variant-ID mismatch at', idx);
                        return;
                    }

                    const preview = buildPreviewEl(designUrl, designId);

                    // Place image between content and sub-content
                    const content = itemEl.querySelector('.qsc2-product-item__content');
                    const subContent = itemEl.querySelector('.qsc-product-item__sub-content');

                    if (content && subContent && subContent.parentElement === content) {
                        content.insertBefore(preview, subContent);
                    } else if (content) {
                        content.appendChild(preview);
                    } else {
                        itemEl.appendChild(preview);
                    }
                } catch (itemErr) {
                    warn('inject item', idx, 'failed', itemErr);
                }
            });
        } catch (err) {
            warn('injectAll failed', err);
        } finally {
            attachObserverNow();
        }
    }

    let scheduleId = null;
    function scheduleInject() {
        if (!active) return;
        clearTimeout(scheduleId);
        scheduleId = setTimeout(async () => {
            try {
                await refreshCart();
                injectAll();
            } catch (e) {
                warn('schedule failed', e);
            }
        }, 50);
    }

    function attachObserverNow() {
        const container = document.querySelector(CONTAINER_SELECTOR);
        if (!container || !observer || !active) return;
        try {
            observer.observe(container, { childList: true, subtree: true });
        } catch (e) {
            warn('observer attach failed', e);
        }
    }

    function hookFetch() {
        try {
            const origFetch = window.fetch;
            if (!origFetch || origFetch.__designerHooked) return;

            const hooked = function(...args) {
                const promise = origFetch.apply(this, args);
                if (!active) return promise;
                try {
                    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
                    if (/\/cart\/(add|change|update|clear)/.test(url)) {
                        promise.then(() => {
                            cartCache = null;
                            scheduleInject();
                        }).catch(() => {});
                    }
                } catch (e) {
                    warn('fetch hook error', e);
                }
                return promise;
            };
            hooked.__designerHooked = true;
            window.fetch = hooked;
        } catch (e) {
            warn('fetch hook setup failed', e);
        }
    }

    function waitForQikify(startTime) {
        const container = document.querySelector(CONTAINER_SELECTOR);
        if (container) {
            log('qikify found, activating');
            active = true;
            try {
                observer = new MutationObserver(scheduleInject);
                attachObserverNow();
                hookFetch();
                scheduleInject();
            } catch (e) {
                warn('start failed', e);
                active = false;
            }
            return;
        }
        if (Date.now() - startTime > MAX_WAIT_MS) {
            log('qikify not found within', MAX_WAIT_MS, 'ms – giving up');
            return;
        }
        setTimeout(() => waitForQikify(startTime), 500);
    }

    try {
        waitForQikify(Date.now());
        if (DEBUG) window.designerInject = scheduleInject;
    } catch (e) {
        warn('init failed', e);
    }
})();
